import React, {useEffect} from 'react';
import {connect} from 'react-redux'
import { useParams } from 'react-router-dom';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import { MerchantSummaryPDF } from '../../../components/Merchant';
import { NoteListPDF } from '../../../components/Note';

import { CircularProgress, Backdrop } from '@mui/material';

import queryString from 'query-string';
import useClasses from '../../../helpers/useClasses';
import { usePDF } from 'react-to-pdf';
import moment from 'moment';


const styles = theme => ({
  root: {
    padding: theme.spacing(3),
    fontSize: '16pt',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    backgroundColor: '#fff',
    minHeight: '100%'
  },
  content: {
    margin: '25px',
    minHeight: '100%'
  },
  header: {
    fontSize: '20pt',
    fontWeight: 'bold',
    marginLeft: '25px'
  },
  date: {
    fontSize: '12pt',
    textAlign: 'right',
    margin: '25px'
  },
  letterhead: {
    margin: '25px',
    paddingTop: '25px'
  },
  button_bar: {
    borderBottom: '1px solid #000'
  },
  button_bar_button: {
    backgroundColor: '#17507f',
    padding: '5px',
    borderRadius: '4px',
    color: '#fff',
    marginBottom: '20px',
    cursor: 'pointer'
  },
  fineprint: {
    fontSize: '10pt',
    margin: '25px',
    marginTop: '100px'
  }
});

const MerchantPDF = props => {
  const classes = useClasses(styles);
  
  const { onFetchMerchant, merchant, accounts, is_dm_admin, is_admin, account_merchant_subscription_enabled, plan_level, merchant_add, onToggleMerchantSubscription, onFetchMembers, loading_accounts, token} = props
  const { toPDF, targetRef } = usePDF({filename: 'DataMerch-'+merchant.fein+'.pdf'});
  
  const { id } = useParams()

  const parsed = queryString.parse(window.location.search)
  const highlight = parsed.highlight || null

  useEffect(() => {
    onFetchMerchant(token, id)
    onFetchMembers(token)
  }, [onFetchMerchant, token, id])

  const handleMerchantSubscriptionToggle = (event) => {
    onToggleMerchantSubscription(merchant.resource_id)
  };

  let spinner = (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
  if(!props.saving){
    spinner = null
  }
  
  return (
    <div className={classes.root}>
      <div className={classes.button_bar}>
        <button className={classes.button_bar_button} onClick={() => toPDF()}>Download PDF</button>
      </div>
      <div className={classes.content} ref={targetRef}>
        <div className={classes.date}>
          {moment(new Date()).format('MM/DD/YYYY')} 
        </div>
        <div className={classes.letterhead}>
          <img
            alt="Logo"
            src="/images/logos/logo.png"
            height="40px"
          />
        </div>
        <div className={classes.header}>
          Merchant Details
        </div>
        <MerchantSummaryPDF
          merchant={merchant}
          is_dm_admin={is_dm_admin}
          is_admin={is_admin}
          account_merchant_subscription_enabled={account_merchant_subscription_enabled}
          onMerchantSubscriptionToggle={handleMerchantSubscriptionToggle}
          plan_level={plan_level}
        />
        <div className={classes.header}>
          Merchant Notes
        </div>
        <NoteListPDF
          className={classes.members}
          merchantId={id}
          accounts={accounts}
          loading_accounts={loading_accounts}
          is_dm_admin={is_dm_admin}
          merchant_add={undefined}
          highlight={highlight}
        />
        {spinner}
        <footer className={classes.fineprint}>
          DataMerch LLC or its members do not constitute a "consumer report" as that term is defined in the federal Fair Credit Reporting Act, 15 USC 1681 et seq. (FCRA). DataMerch LLC only accepts, stores, and distributes data on commercial entities. User is prohibited from providing information on individual persons or consumers. Information listed on DataMerch LLC may not be used in whole or in part as a factor in determining eligibility for personal credit, insurance, employment or another permissible purpose under the FCRA. It is the policy of DataMerch LLC to view sole-proprietors, single-shareholder corporations, single-member partnerships and single-member companies as commercial entities and never as individuals or consumers. Businesses may directly request removal 7 years from the date of entry. Businesses may post a statement of disagreement to the record.
        </footer>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    merchant: state.merchant.merchant,
    saving: state.merchant.saving,
    token: state.auth.token,
    is_dm_admin: state.auth.user.is_dm_admin,
    loading_accounts: state.account.loading,
    accounts: state.account.accounts,
    is_admin: state.auth.user.is_admin,
    account_merchant_subscription_enabled: state.auth.user.account_merchant_subscription_enabled,
    plan_level: state.auth.user.plan_level
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchMerchant: (token, id) => dispatch(actions.fetchMerchant(token, id)),
    onMerchantSave: (merchantData, id) => dispatch(actions.updateMerchant(merchantData, id)),
    onFetchMembers: (token) => dispatch(actions.fetchDatamerchMembers(token)),
    onToggleMerchantSubscription: (id) => dispatch(actions.toggleMerchantSubscription(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(MerchantPDF, axios))